
import "./App.css";
import React from "react";

import Landing from "./views/landing";

function App() {
  return (<Landing /> );
}

export default App;
